import { WprBaseDIManage } from './WprBaseDIManage';
import { WprFramework } from '../../WprFramework';

/**
 * オブジェクトDIデコレータ
 * @param target ビュー情報
 * @param props プロパティ名
 */
export function WprDI_Object(target: any, props: string) {
	const diManage = target as WprBaseDIManage;
	if (diManage)
		WprFramework.getInstance().model.addDecoListInfo('Object', diManage, props);
}
